import React, { useState, useEffect, useMemo } from 'react'
import { isEmpty } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import { useAuth } from 'lib/auth'
import initializeFeatures from './initializeFeatures'
import FeatureFlagContext from './FeatureFlagContext'
import FeatureFlagStatusContext from './FeatureFlagStatusContext'

const getFlagEntityKey = user => user?.externalId ?? null

const withFeatureFlagProvider = App => props => {
  const { user } = useAuth()
  const [evaluation, setEvaluation] = useState({
    featureFlags: {},
    entityKey: null,
  })
  const entityKey = getFlagEntityKey(user)

  useEffect(() => {
    let cancelled = false
    const getFeatures = async () => {
      const flags = await initializeFeatures(user)
      if (!cancelled) {
        setEvaluation({
          featureFlags: flags,
          entityKey: getFlagEntityKey(user),
        })
      }
    }
    getFeatures()
    return () => {
      cancelled = true
    }
  }, [user])

  // The user signs in after the first render, so the first evaluation is
  // anonymous. Until the signed-in evaluation lands the flags are stale.
  const isLoading = evaluation.entityKey !== entityKey
  const status = useMemo(() => ({ isLoading }), [isLoading])

  if (isEmpty(evaluation.featureFlags)) {
    return <LinearProgress color="primary" />
  }

  return (
    <FeatureFlagContext.Provider value={evaluation.featureFlags}>
      <FeatureFlagStatusContext.Provider value={status}>
        <App {...props} />
      </FeatureFlagStatusContext.Provider>
    </FeatureFlagContext.Provider>
  )
}

export default withFeatureFlagProvider
